var a = {
  "@@functional/placeholder": !0
};
export { a as default };
